import { useContext } from 'react';
import { TenantConfigContext } from './TenantConfigContext.js';

function validateInsideContext(context) {
  if (context === undefined) {
    throw new Error('Wrap your Component in a TenantConfigContext Component');
  }
}
function useTenantConfig() {
  const context = useContext(TenantConfigContext);
  validateInsideContext(context);
  return context.config;
}
function useTenantConfigStatus() {
  const context = useContext(TenantConfigContext);
  validateInsideContext(context);
  return {
    error: context.error,
    loading: context.loading
  };
}

export { useTenantConfig, useTenantConfigStatus };
//# sourceMappingURL=useTenantConfig.js.map
